// extracted by mini-css-extract-plugin
module.exports = {"hidden":"xO1OZ8Yw","container":"_SObEGpO","avatar":"_5Abg_6pb","name":"Z8a_lPCu","id":"gcyYnPly"};